// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Appointment Container */
.patient-apt-container {
    margin: 2rem;
    padding: 10px;
    /* max-width: 90%;  */
    border: 3px solid var(--clr-primary-3);
    font-family: var(--ff-primary, 'Poppins', sans-serif);
    /* background-color: var(--clr-primary-7); */
    color: var(--clr-grey-1);
    border-radius: var(--radius);
    box-shadow: var(--shadow-2);
    transition: var(--transition);
    position: relative; 
    min-height: 80vh; 
    /* display: flex; */
    flex-direction: column;
    justify-content: center;
    align-items: center;
}

/* Centered Loading Spinner */
.patient-apt-loading-container {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
}

/* Loading Spinner */
.patient-apt-spinner {
    width: 50px;
    height: 50px;
    border: 6px solid var(--clr-primary-6);
    border-top: 6px solid var(--clr-primary-3);
    border-radius: 50%;
    animation: spin 1s linear infinite;
}

/* Loading Text */
.patient-apt-loading-text {
    font-size: 16px;
    color: var(--clr-grey-3);
    margin-top: 10px;
    font-weight: 500;
}

/* Filters Container */
.patient-apt-filter-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    gap: 15px;
    margin-bottom: 20px;
}

.patient-apt-filters {
    display: flex;
    align-items: center;
    gap: 10px; /* Adjusts spacing between filter & search */
}
/* 🔹 Heading Styling */
.patient-apt-heading {
    font-size: 24px;
    font-weight: bold;
    color: var(--clr-grey-1);
    text-align: center;
    margin-bottom: 20px;
    position: relative;
    text-transform: uppercase;
    letter-spacing: 1px;
}

/* 🔹  Underline Effect */
.patient-apt-heading::after {
    content: "";
    width: 10rem;
    height: 3px;
    background-color: var(--clr-grey-3);
    position: absolute;
    left: 50%;
    bottom: -5px;
    transform: translateX(-50%);
    border-radius: var(--borderRadius);
}


/* Dropdown Width */
.patient-apt-filter-container select {
    background-color: var(--clr-white);
    cursor: pointer;
    width: 180px;
    height: 40px;
    padding: 8px 12px;
    border-radius: var(--borderRadius);
    border: 1px solid var(--grey-400);
    font-size: 14px;
    color: var(--textColor);
}

/*  Search Input Width & Height */
.patient-apt-filter-container input {
    max-width: 300px;
    width: 100%;
    flex-grow: 1;
    min-width: 220px;
    height: 40px;
    padding: 8px 12px;
    border-radius: var(--borderRadius);
    border: 1px solid var(--grey-400);
    font-size: 14px;
    color: var(--textColor);
    background-color: var(--clr-white);
}

/* Grid Layout - 3 Cards Per Row */
.patient-apt-grid {
    display: grid;
    grid-template-columns: repeat(3, minmax(280px, 1fr));
    gap: 20px;
}

/*  Appointment Card */
.patient-apt-card {
    background: var(--clr-white);
    border-radius: var(--radius);
    padding: 20px;
    box-shadow: var(--shadow-2);
    transition: var(--transition);
    position: relative;
    border: 1px solid var(--grey-200);
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 180px;
    overflow: hidden;
}

.patient-apt-card:hover {
    transform: translateY(-5px);
    box-shadow: var(--shadow-3);
    border-color: var(--clr-primary-6);
}

/* Doctor Name Styling  */
.patient-apt-card h3 {
    font-size: 22px;
    font-weight: bold;
    color: var(--clr-grey-1);
    margin-bottom: 12px;
}

/*  Appointment Date & Time */
.patient-apt-card p {
    font-size: 15px;
    color: var(--clr-grey-3);
    margin: 5px 0;
}

/*  Status Styling */
.patient-apt-status {
    font-size: 15px;
    font-weight: bold;
    color: var(--clr-grey-2);
    background-color: var(--grey-100);
    padding: 6px 12px;
    border-radius: var(--borderRadius);
    display: inline-block;
    margin-top: 8px;
}

/* View Details Button */
.patient-apt-details-button {
    background: var(--clr-primary-5);
    color: var(--clr-white);
    padding: 10px 16px;
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    font-size: 15px;
    font-weight: bold;
    transition: var(--transition);
    align-self: flex-start;
    margin-top: auto;
}

.patient-apt-details-button:hover {
    background: var(--clr-primary-3);
    transform: scale(1.05);
}


/*  Pagination  */
.patient-apt-pagination {
    display: flex;
    justify-content: center;
    margin-top: 25px;
    gap: 10px;
    flex-wrap: wrap;
}

/* Pagination Buttons */
.patient-apt-pagination button {
    padding: 8px 14px;
    border-radius: var(--borderRadius);
    border: 1px solid var(--clr-primary-5);
    background: var(--clr-white);
    color: var(--clr-primary-5);
    cursor: pointer;
    font-size: 14px;
    transition: var(--transition);
}

.patient-apt-pagination button.active {
    background-color: var(--clr-primary-5);
    color: var(--clr-white);
}

.patient-apt-pagination button:hover {
    background-color: var(--clr-primary-3);
    color: var(--clr-white);
}

.patient-apt-pagination button:disabled {
    cursor: not-allowed;
    opacity: 0.5;
}

/* Empty State Container */
.patient-apt-empty-container {
    display: flex;
    justify-content: center;
    align-items: center;
    height: 70vh; /* Slightly increased for better positioning */
    text-align: center;
    padding: 20px;
}

/* 🔹 Empty State Card */
.patient-apt-empty-card {
    background: var(--clr-white);
    padding: 40px; 
    border-radius: var(--radius);
    box-shadow: var(--shadow-3); 
    max-width: 600px;
    text-align: center;
    border: 1px solid var(--clr-grey-1); 
    transition: var(--transition);
}

.patient-apt-empty-card:hover {
    transform: translateY(-3px);
    box-shadow: var(--shadow-4);
}

/* Empty State Title */
.patient-apt-empty-title {
    font-size: 24px; 
    font-weight: bold;
    color: var(--clr-grey-1);
    margin-bottom: 15px;
}

/* Empty State Message */
.patient-apt-empty-message {
    font-size: 18px; 
    color: var(--clr-grey-3);
    margin-bottom: 12px;
    font-weight: 500;
}

/* Empty State Suggestion */
.patient-apt-empty-suggestion {
    font-size: 16px;
    color: var(--clr-grey-5);
    margin-bottom: 20px;
    font-weight: 400;
}

/* Book Appointment Button */
.patient-apt-book-button {
    background: var(--clr-primary-5);
    color: var(--clr-white);
    padding: 12px 20px;
    font-size: 18px;
    font-weight: bold;
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    transition: var(--transition);
    box-shadow: var(--shadow-2);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* Button Hover Effect */
.patient-apt-book-button:hover {
    background: var(--clr-primary-3);
    transform: translateY(-2px);
    box-shadow: var(--shadow-3);
}

.modal-overlay-patient-appt {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000; /* ⬅️ Raised for safety */
  }
  
/* Modal Container (Centered) */
.modal-container-patient-appt {
    background: var(--clr-white);
    width: 90%;
    max-width: 900px;
    padding: 25px;
    border-radius: var(--radius);
    box-shadow: var(--shadow-3);
    position: relative;
    animation: fadeIn 0.3s ease-in-out;
}

/* Title (Centered) */
.modal-title-patient-appt {
    text-align: center;
    color: var(--clr-primary-4);
    font-size: 1.7rem;
    font-weight: 700;
    margin-bottom: 1.2rem;
    font-family: var(--ff-primary);
}

/* Sections Layout (Side-by-side on desktop) */
.modal-sections-container {
    display: flex;
    gap: 20px;
}

/* Each Section */
.modal-section-patient-appt {
    flex: 1 1;
    background: var(--clr-grey-9);
    padding: 15px;
    border-radius: var(--radius);
    box-shadow: var(--shadow-1);
    min-width: 0; /* Prevents flex shrink issues */
}

/* Subtitle */
.modal-subtitle-patient-appt {
    font-size: 1.3rem;
    font-weight: bold;
    color: var(--clr-grey-1);
    margin-bottom: 12px;
    text-align: center;
}

/* Table-Like Layout */
.modal-content-patient-appt {
    display: flex;
    flex-direction: column;
    gap: 12px;
}

/* Row Styling */
.modal-row-patient-appt {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    padding: 8px 0;
    border-bottom: 1px solid var(--clr-grey-7);
}

/* Label Styling */
.modal-label-patient-appt {
    font-weight: bold;
    color: var(--clr-grey-2);
    margin-bottom: 5px;
    width: 100%;
}

/* Value Styling */
.modal-value-patient-appt {
    color: var(--clr-grey-4);
    line-height: 1.5;
    word-wrap: break-word;
    font-size: 0.95rem;
}

/* Loading Text */
.modal-loading-patient-appt {
    text-align: center;
    font-size: 1rem;
    color: var(--clr-primary-5);
}

/* Close Button (Top Right) */
.modal-close-btn-patient-appt {
    position: absolute;
    top: 10px;
    right: 15px;
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
    color: var(--clr-grey-3);
    transition: var(--transition);
}

.modal-close-btn-patient-appt:hover {
    color: var(--clr-primary-5);
}

/* Close Button (Bottom) */
.modal-footer-btn-patient-appt {
    display: block;
    width: auto; /* Adjust width based on content */
    padding: 12px 24px; /* Adjust padding for better aesthetics */
    background: var(--clr-primary-5);
    color: var(--clr-white);
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    font-size: 1rem;
    font-weight: bold;
    transition: var(--transition);
    margin: 15px auto 0; /* Centers button horizontally */
    text-align: center;
}
.modal-footer-btn-patient-appt {
    display: block;
    width: auto; /* Adjust width based on content */
    padding: 12px 24px; /* Adjust padding for better aesthetics */
    background: var(--clr-primary-5);
    color: var(--clr-white);
    border: none;
    border-radius: var(--radius);
    cursor: pointer;
    font-size: 1rem;
    font-weight: bold;
    transition: var(--transition);
    margin: 15px auto 0; /* Centers button horizontally */
    text-align: center;
}


.modal-footer-btn-patient-appt:hover {
    background: var(--clr-primary-3);
}

/* Animations */
@keyframes fadeIn {
    from {
        opacity: 0;
        transform: scale(0.9);
    }
    to {
        opacity: 1;
        transform: scale(1);
    }
}

/* Responsive: Stack Sections */
@media (max-width: 768px) {
    .modal-container-patient-appt {
        width: 95%;
        padding: 20px;
    }

    .modal-sections-container {
        flex-direction: column;
        gap: 15px;
    }

    .modal-title-patient-appt {
        font-size: 1.5rem;
    }

    .modal-subtitle-patient-appt {
        font-size: 1.1rem;
    }

    .modal-label-patient-appt,
    .modal-value-patient-appt {
        font-size: 0.9rem;
    }

    .modal-footer-btn-patient-appt {
        font-size: 0.9rem;
    }
}

  
/* Responsive Fixes */
@media screen and (max-width: 768px) {
    .patient-apt-empty-container {
        height: auto;
        padding: 20px;
    }

    .patient-apt-empty-card {
        padding: 30px;
        max-width: 90%;
    }

    .patient-apt-empty-title {
        font-size: 22px;
    }

    .patient-apt-empty-message {
        font-size: 16px;
    }

    .patient-apt-empty-suggestion {
        font-size: 15px;
    }

    .patient-apt-book-button {
        font-size: 16px;
        padding: 10px 16px;
    }
}

/*Responsive Adjustments */
@media screen and (max-width: 1200px) {
    .patient-apt-grid {
        grid-template-columns: repeat(3, 1fr);
    }
}

@media screen and (max-width: 1024px) {
    .patient-apt-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

/* Existing Responsive Styles */
@media screen and (max-width: 768px) {
    .patient-apt-grid {
        grid-template-columns: repeat(1, 1fr);
    }

    .patient-apt-filter-container {
        flex-direction: column;
        gap: 10px;
        align-items: stretch; /* Ensures items take full width */
    }

    .patient-apt-filters {
        /* flex-direction: column; */
        width: 100%; /* Makes filters stack properly */
        gap: 10px;
    }

    .patient-apt-filter-select,
    .patient-apt-filter-input {
        width: 100%; /* Full width for better usability */
    }

    .patient-apt-back-button {
        width: 100%;
        text-align: center; /* Centers text inside button */
        margin-top: 10px;
    }
}


/* Spinner Animation */
@keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
}

/* Responsive Adjustments */
@media screen and (max-width: 1200px) {
    .patient-apt-container {
        padding: 30px;
    }
}

@media screen and (max-width: 768px) {
    .patient-apt-container {
        padding: 10px;
    }
}

.soap-label {
    font-size: 0.9rem;
    color: var(--clr-grey-1); 
    font-weight: normal;
  }
  `, "",{"version":3,"sources":["webpack://./src/components/Scheduling/styles/PatientAppointmentsView.css"],"names":[],"mappings":"AAAA,0BAA0B;AAC1B;IACI,YAAY;IACZ,aAAa;IACb,qBAAqB;IACrB,sCAAsC;IACtC,qDAAqD;IACrD,4CAA4C;IAC5C,wBAAwB;IACxB,4BAA4B;IAC5B,2BAA2B;IAC3B,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,0CAA0C;IAC1C,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,wBAAwB;IACxB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;IACf,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS,EAAE,4CAA4C;AAC3D;AACA,uBAAuB;AACvB;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,WAAW;IACX,YAAY;IACZ,WAAW;IACX,mCAAmC;IACnC,kBAAkB;IAClB,SAAS;IACT,YAAY;IACZ,2BAA2B;IAC3B,kCAAkC;AACtC;;;AAGA,mBAAmB;AACnB;IACI,kCAAkC;IAClC,eAAe;IACf,YAAY;IACZ,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;IAClC,iCAAiC;IACjC,eAAe;IACf,uBAAuB;AAC3B;;AAEA,iCAAiC;AACjC;IACI,gBAAgB;IAChB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,kCAAkC;IAClC,iCAAiC;IACjC,eAAe;IACf,uBAAuB;IACvB,kCAAkC;AACtC;;AAEA,kCAAkC;AAClC;IACI,aAAa;IACb,oDAAoD;IACpD,SAAS;AACb;;AAEA,sBAAsB;AACtB;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,aAAa;IACb,2BAA2B;IAC3B,6BAA6B;IAC7B,kBAAkB;IAClB,iCAAiC;IACjC,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;IAC3B,kCAAkC;AACtC;;AAEA,yBAAyB;AACzB;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,eAAe;IACf,wBAAwB;IACxB,aAAa;AACjB;;AAEA,oBAAoB;AACpB;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,iCAAiC;IACjC,iBAAiB;IACjB,kCAAkC;IAClC,qBAAqB;IACrB,eAAe;AACnB;;AAEA,wBAAwB;AACxB;IACI,gCAAgC;IAChC,uBAAuB;IACvB,kBAAkB;IAClB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,sBAAsB;IACtB,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,sBAAsB;AAC1B;;;AAGA,iBAAiB;AACjB;IACI,aAAa;IACb,uBAAuB;IACvB,gBAAgB;IAChB,SAAS;IACT,eAAe;AACnB;;AAEA,uBAAuB;AACvB;IACI,iBAAiB;IACjB,kCAAkC;IAClC,sCAAsC;IACtC,4BAA4B;IAC5B,2BAA2B;IAC3B,eAAe;IACf,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;IACnB,YAAY;AAChB;;AAEA,0BAA0B;AAC1B;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY,EAAE,8CAA8C;IAC5D,kBAAkB;IAClB,aAAa;AACjB;;AAEA,wBAAwB;AACxB;IACI,4BAA4B;IAC5B,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;IAC3B,gBAAgB;IAChB,kBAAkB;IAClB,mCAAmC;IACnC,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA,sBAAsB;AACtB;IACI,eAAe;IACf,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;AACvB;;AAEA,wBAAwB;AACxB;IACI,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,2BAA2B;AAC3B;IACI,eAAe;IACf,wBAAwB;IACxB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA,4BAA4B;AAC5B;IACI,gCAAgC;IAChC,uBAAuB;IACvB,kBAAkB;IAClB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,6BAA6B;IAC7B,2BAA2B;IAC3B,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA,wBAAwB;AACxB;IACI,gCAAgC;IAChC,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,aAAa,EAAE,yBAAyB;EAC1C;;AAEF,+BAA+B;AAC/B;IACI,4BAA4B;IAC5B,UAAU;IACV,gBAAgB;IAChB,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;IAC3B,kBAAkB;IAClB,kCAAkC;AACtC;;AAEA,qBAAqB;AACrB;IACI,kBAAkB;IAClB,2BAA2B;IAC3B,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;IACrB,8BAA8B;AAClC;;AAEA,8CAA8C;AAC9C;IACI,aAAa;IACb,SAAS;AACb;;AAEA,iBAAiB;AACjB;IACI,SAAO;IACP,6BAA6B;IAC7B,aAAa;IACb,4BAA4B;IAC5B,2BAA2B;IAC3B,YAAY,EAAE,gCAAgC;AAClD;;AAEA,aAAa;AACb;IACI,iBAAiB;IACjB,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA,sBAAsB;AACtB;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;AACb;;AAEA,gBAAgB;AAChB;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,cAAc;IACd,0CAA0C;AAC9C;;AAEA,kBAAkB;AAClB;IACI,iBAAiB;IACjB,wBAAwB;IACxB,kBAAkB;IAClB,WAAW;AACf;;AAEA,kBAAkB;AAClB;IACI,wBAAwB;IACxB,gBAAgB;IAChB,qBAAqB;IACrB,kBAAkB;AACtB;;AAEA,iBAAiB;AACjB;IACI,kBAAkB;IAClB,eAAe;IACf,2BAA2B;AAC/B;;AAEA,6BAA6B;AAC7B;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,gBAAgB;IAChB,YAAY;IACZ,iBAAiB;IACjB,eAAe;IACf,wBAAwB;IACxB,6BAA6B;AACjC;;AAEA;IACI,2BAA2B;AAC/B;;AAEA,0BAA0B;AAC1B;IACI,cAAc;IACd,WAAW,EAAE,kCAAkC;IAC/C,kBAAkB,EAAE,yCAAyC;IAC7D,gCAAgC;IAChC,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB,EAAE,gCAAgC;IACrD,kBAAkB;AACtB;AACA;IACI,cAAc;IACd,WAAW,EAAE,kCAAkC;IAC/C,kBAAkB,EAAE,yCAAyC;IAC7D,gCAAgC;IAChC,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,eAAe;IACf,eAAe;IACf,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB,EAAE,gCAAgC;IACrD,kBAAkB;AACtB;;;AAGA;IACI,gCAAgC;AACpC;;AAEA,eAAe;AACf;IACI;QACI,UAAU;QACV,qBAAqB;IACzB;IACA;QACI,UAAU;QACV,mBAAmB;IACvB;AACJ;;AAEA,+BAA+B;AAC/B;IACI;QACI,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;;IAEA;;QAEI,iBAAiB;IACrB;;IAEA;QACI,iBAAiB;IACrB;AACJ;;;AAGA,qBAAqB;AACrB;IACI;QACI,YAAY;QACZ,aAAa;IACjB;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,kBAAkB;IACtB;AACJ;;AAEA,0BAA0B;AAC1B;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA,+BAA+B;AAC/B;IACI;QACI,qCAAqC;IACzC;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,oBAAoB,EAAE,kCAAkC;IAC5D;;IAEA;QACI,4BAA4B;QAC5B,WAAW,EAAE,iCAAiC;QAC9C,SAAS;IACb;;IAEA;;QAEI,WAAW,EAAE,oCAAoC;IACrD;;IAEA;QACI,WAAW;QACX,kBAAkB,EAAE,+BAA+B;QACnD,gBAAgB;IACpB;AACJ;;;AAGA,sBAAsB;AACtB;IACI,KAAK,uBAAuB,EAAE;IAC9B,OAAO,yBAAyB,EAAE;AACtC;;AAEA,2BAA2B;AAC3B;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,iBAAiB;IACjB,wBAAwB;IACxB,mBAAmB;EACrB","sourcesContent":["/* Appointment Container */\n.patient-apt-container {\n    margin: 2rem;\n    padding: 10px;\n    /* max-width: 90%;  */\n    border: 3px solid var(--clr-primary-3);\n    font-family: var(--ff-primary, 'Poppins', sans-serif);\n    /* background-color: var(--clr-primary-7); */\n    color: var(--clr-grey-1);\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-2);\n    transition: var(--transition);\n    position: relative; \n    min-height: 80vh; \n    /* display: flex; */\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n}\n\n/* Centered Loading Spinner */\n.patient-apt-loading-container {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n}\n\n/* Loading Spinner */\n.patient-apt-spinner {\n    width: 50px;\n    height: 50px;\n    border: 6px solid var(--clr-primary-6);\n    border-top: 6px solid var(--clr-primary-3);\n    border-radius: 50%;\n    animation: spin 1s linear infinite;\n}\n\n/* Loading Text */\n.patient-apt-loading-text {\n    font-size: 16px;\n    color: var(--clr-grey-3);\n    margin-top: 10px;\n    font-weight: 500;\n}\n\n/* Filters Container */\n.patient-apt-filter-container {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    flex-wrap: wrap;\n    gap: 15px;\n    margin-bottom: 20px;\n}\n\n.patient-apt-filters {\n    display: flex;\n    align-items: center;\n    gap: 10px; /* Adjusts spacing between filter & search */\n}\n/* 🔹 Heading Styling */\n.patient-apt-heading {\n    font-size: 24px;\n    font-weight: bold;\n    color: var(--clr-grey-1);\n    text-align: center;\n    margin-bottom: 20px;\n    position: relative;\n    text-transform: uppercase;\n    letter-spacing: 1px;\n}\n\n/* 🔹  Underline Effect */\n.patient-apt-heading::after {\n    content: \"\";\n    width: 10rem;\n    height: 3px;\n    background-color: var(--clr-grey-3);\n    position: absolute;\n    left: 50%;\n    bottom: -5px;\n    transform: translateX(-50%);\n    border-radius: var(--borderRadius);\n}\n\n\n/* Dropdown Width */\n.patient-apt-filter-container select {\n    background-color: var(--clr-white);\n    cursor: pointer;\n    width: 180px;\n    height: 40px;\n    padding: 8px 12px;\n    border-radius: var(--borderRadius);\n    border: 1px solid var(--grey-400);\n    font-size: 14px;\n    color: var(--textColor);\n}\n\n/*  Search Input Width & Height */\n.patient-apt-filter-container input {\n    max-width: 300px;\n    width: 100%;\n    flex-grow: 1;\n    min-width: 220px;\n    height: 40px;\n    padding: 8px 12px;\n    border-radius: var(--borderRadius);\n    border: 1px solid var(--grey-400);\n    font-size: 14px;\n    color: var(--textColor);\n    background-color: var(--clr-white);\n}\n\n/* Grid Layout - 3 Cards Per Row */\n.patient-apt-grid {\n    display: grid;\n    grid-template-columns: repeat(3, minmax(280px, 1fr));\n    gap: 20px;\n}\n\n/*  Appointment Card */\n.patient-apt-card {\n    background: var(--clr-white);\n    border-radius: var(--radius);\n    padding: 20px;\n    box-shadow: var(--shadow-2);\n    transition: var(--transition);\n    position: relative;\n    border: 1px solid var(--grey-200);\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    min-height: 180px;\n    overflow: hidden;\n}\n\n.patient-apt-card:hover {\n    transform: translateY(-5px);\n    box-shadow: var(--shadow-3);\n    border-color: var(--clr-primary-6);\n}\n\n/* Doctor Name Styling  */\n.patient-apt-card h3 {\n    font-size: 22px;\n    font-weight: bold;\n    color: var(--clr-grey-1);\n    margin-bottom: 12px;\n}\n\n/*  Appointment Date & Time */\n.patient-apt-card p {\n    font-size: 15px;\n    color: var(--clr-grey-3);\n    margin: 5px 0;\n}\n\n/*  Status Styling */\n.patient-apt-status {\n    font-size: 15px;\n    font-weight: bold;\n    color: var(--clr-grey-2);\n    background-color: var(--grey-100);\n    padding: 6px 12px;\n    border-radius: var(--borderRadius);\n    display: inline-block;\n    margin-top: 8px;\n}\n\n/* View Details Button */\n.patient-apt-details-button {\n    background: var(--clr-primary-5);\n    color: var(--clr-white);\n    padding: 10px 16px;\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    font-size: 15px;\n    font-weight: bold;\n    transition: var(--transition);\n    align-self: flex-start;\n    margin-top: auto;\n}\n\n.patient-apt-details-button:hover {\n    background: var(--clr-primary-3);\n    transform: scale(1.05);\n}\n\n\n/*  Pagination  */\n.patient-apt-pagination {\n    display: flex;\n    justify-content: center;\n    margin-top: 25px;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n/* Pagination Buttons */\n.patient-apt-pagination button {\n    padding: 8px 14px;\n    border-radius: var(--borderRadius);\n    border: 1px solid var(--clr-primary-5);\n    background: var(--clr-white);\n    color: var(--clr-primary-5);\n    cursor: pointer;\n    font-size: 14px;\n    transition: var(--transition);\n}\n\n.patient-apt-pagination button.active {\n    background-color: var(--clr-primary-5);\n    color: var(--clr-white);\n}\n\n.patient-apt-pagination button:hover {\n    background-color: var(--clr-primary-3);\n    color: var(--clr-white);\n}\n\n.patient-apt-pagination button:disabled {\n    cursor: not-allowed;\n    opacity: 0.5;\n}\n\n/* Empty State Container */\n.patient-apt-empty-container {\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    height: 70vh; /* Slightly increased for better positioning */\n    text-align: center;\n    padding: 20px;\n}\n\n/* 🔹 Empty State Card */\n.patient-apt-empty-card {\n    background: var(--clr-white);\n    padding: 40px; \n    border-radius: var(--radius);\n    box-shadow: var(--shadow-3); \n    max-width: 600px;\n    text-align: center;\n    border: 1px solid var(--clr-grey-1); \n    transition: var(--transition);\n}\n\n.patient-apt-empty-card:hover {\n    transform: translateY(-3px);\n    box-shadow: var(--shadow-4);\n}\n\n/* Empty State Title */\n.patient-apt-empty-title {\n    font-size: 24px; \n    font-weight: bold;\n    color: var(--clr-grey-1);\n    margin-bottom: 15px;\n}\n\n/* Empty State Message */\n.patient-apt-empty-message {\n    font-size: 18px; \n    color: var(--clr-grey-3);\n    margin-bottom: 12px;\n    font-weight: 500;\n}\n\n/* Empty State Suggestion */\n.patient-apt-empty-suggestion {\n    font-size: 16px;\n    color: var(--clr-grey-5);\n    margin-bottom: 20px;\n    font-weight: 400;\n}\n\n/* Book Appointment Button */\n.patient-apt-book-button {\n    background: var(--clr-primary-5);\n    color: var(--clr-white);\n    padding: 12px 20px;\n    font-size: 18px;\n    font-weight: bold;\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    transition: var(--transition);\n    box-shadow: var(--shadow-2);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n/* Button Hover Effect */\n.patient-apt-book-button:hover {\n    background: var(--clr-primary-3);\n    transform: translateY(-2px);\n    box-shadow: var(--shadow-3);\n}\n\n.modal-overlay-patient-appt {\n    position: fixed;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    background: rgba(0, 0, 0, 0.6);\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    z-index: 2000; /* ⬅️ Raised for safety */\n  }\n  \n/* Modal Container (Centered) */\n.modal-container-patient-appt {\n    background: var(--clr-white);\n    width: 90%;\n    max-width: 900px;\n    padding: 25px;\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-3);\n    position: relative;\n    animation: fadeIn 0.3s ease-in-out;\n}\n\n/* Title (Centered) */\n.modal-title-patient-appt {\n    text-align: center;\n    color: var(--clr-primary-4);\n    font-size: 1.7rem;\n    font-weight: 700;\n    margin-bottom: 1.2rem;\n    font-family: var(--ff-primary);\n}\n\n/* Sections Layout (Side-by-side on desktop) */\n.modal-sections-container {\n    display: flex;\n    gap: 20px;\n}\n\n/* Each Section */\n.modal-section-patient-appt {\n    flex: 1;\n    background: var(--clr-grey-9);\n    padding: 15px;\n    border-radius: var(--radius);\n    box-shadow: var(--shadow-1);\n    min-width: 0; /* Prevents flex shrink issues */\n}\n\n/* Subtitle */\n.modal-subtitle-patient-appt {\n    font-size: 1.3rem;\n    font-weight: bold;\n    color: var(--clr-grey-1);\n    margin-bottom: 12px;\n    text-align: center;\n}\n\n/* Table-Like Layout */\n.modal-content-patient-appt {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n}\n\n/* Row Styling */\n.modal-row-patient-appt {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 8px 0;\n    border-bottom: 1px solid var(--clr-grey-7);\n}\n\n/* Label Styling */\n.modal-label-patient-appt {\n    font-weight: bold;\n    color: var(--clr-grey-2);\n    margin-bottom: 5px;\n    width: 100%;\n}\n\n/* Value Styling */\n.modal-value-patient-appt {\n    color: var(--clr-grey-4);\n    line-height: 1.5;\n    word-wrap: break-word;\n    font-size: 0.95rem;\n}\n\n/* Loading Text */\n.modal-loading-patient-appt {\n    text-align: center;\n    font-size: 1rem;\n    color: var(--clr-primary-5);\n}\n\n/* Close Button (Top Right) */\n.modal-close-btn-patient-appt {\n    position: absolute;\n    top: 10px;\n    right: 15px;\n    background: none;\n    border: none;\n    font-size: 1.5rem;\n    cursor: pointer;\n    color: var(--clr-grey-3);\n    transition: var(--transition);\n}\n\n.modal-close-btn-patient-appt:hover {\n    color: var(--clr-primary-5);\n}\n\n/* Close Button (Bottom) */\n.modal-footer-btn-patient-appt {\n    display: block;\n    width: auto; /* Adjust width based on content */\n    padding: 12px 24px; /* Adjust padding for better aesthetics */\n    background: var(--clr-primary-5);\n    color: var(--clr-white);\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    font-size: 1rem;\n    font-weight: bold;\n    transition: var(--transition);\n    margin: 15px auto 0; /* Centers button horizontally */\n    text-align: center;\n}\n.modal-footer-btn-patient-appt {\n    display: block;\n    width: auto; /* Adjust width based on content */\n    padding: 12px 24px; /* Adjust padding for better aesthetics */\n    background: var(--clr-primary-5);\n    color: var(--clr-white);\n    border: none;\n    border-radius: var(--radius);\n    cursor: pointer;\n    font-size: 1rem;\n    font-weight: bold;\n    transition: var(--transition);\n    margin: 15px auto 0; /* Centers button horizontally */\n    text-align: center;\n}\n\n\n.modal-footer-btn-patient-appt:hover {\n    background: var(--clr-primary-3);\n}\n\n/* Animations */\n@keyframes fadeIn {\n    from {\n        opacity: 0;\n        transform: scale(0.9);\n    }\n    to {\n        opacity: 1;\n        transform: scale(1);\n    }\n}\n\n/* Responsive: Stack Sections */\n@media (max-width: 768px) {\n    .modal-container-patient-appt {\n        width: 95%;\n        padding: 20px;\n    }\n\n    .modal-sections-container {\n        flex-direction: column;\n        gap: 15px;\n    }\n\n    .modal-title-patient-appt {\n        font-size: 1.5rem;\n    }\n\n    .modal-subtitle-patient-appt {\n        font-size: 1.1rem;\n    }\n\n    .modal-label-patient-appt,\n    .modal-value-patient-appt {\n        font-size: 0.9rem;\n    }\n\n    .modal-footer-btn-patient-appt {\n        font-size: 0.9rem;\n    }\n}\n\n  \n/* Responsive Fixes */\n@media screen and (max-width: 768px) {\n    .patient-apt-empty-container {\n        height: auto;\n        padding: 20px;\n    }\n\n    .patient-apt-empty-card {\n        padding: 30px;\n        max-width: 90%;\n    }\n\n    .patient-apt-empty-title {\n        font-size: 22px;\n    }\n\n    .patient-apt-empty-message {\n        font-size: 16px;\n    }\n\n    .patient-apt-empty-suggestion {\n        font-size: 15px;\n    }\n\n    .patient-apt-book-button {\n        font-size: 16px;\n        padding: 10px 16px;\n    }\n}\n\n/*Responsive Adjustments */\n@media screen and (max-width: 1200px) {\n    .patient-apt-grid {\n        grid-template-columns: repeat(3, 1fr);\n    }\n}\n\n@media screen and (max-width: 1024px) {\n    .patient-apt-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n/* Existing Responsive Styles */\n@media screen and (max-width: 768px) {\n    .patient-apt-grid {\n        grid-template-columns: repeat(1, 1fr);\n    }\n\n    .patient-apt-filter-container {\n        flex-direction: column;\n        gap: 10px;\n        align-items: stretch; /* Ensures items take full width */\n    }\n\n    .patient-apt-filters {\n        /* flex-direction: column; */\n        width: 100%; /* Makes filters stack properly */\n        gap: 10px;\n    }\n\n    .patient-apt-filter-select,\n    .patient-apt-filter-input {\n        width: 100%; /* Full width for better usability */\n    }\n\n    .patient-apt-back-button {\n        width: 100%;\n        text-align: center; /* Centers text inside button */\n        margin-top: 10px;\n    }\n}\n\n\n/* Spinner Animation */\n@keyframes spin {\n    0% { transform: rotate(0deg); }\n    100% { transform: rotate(360deg); }\n}\n\n/* Responsive Adjustments */\n@media screen and (max-width: 1200px) {\n    .patient-apt-container {\n        padding: 30px;\n    }\n}\n\n@media screen and (max-width: 768px) {\n    .patient-apt-container {\n        padding: 10px;\n    }\n}\n\n.soap-label {\n    font-size: 0.9rem;\n    color: var(--clr-grey-1); \n    font-weight: normal;\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
